/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
// import Vue from "vue";
window.Vue = require('vue').default;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import {BootstrapVue, IconsPlugin} from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Vuex from 'vuex';
import storeConfig from './common/store';
import 'chosen-js/chosen.css';
import 'chosen-js/chosen.jquery.js';
import './index';
import 'chosen-js/chosen.css';
import 'chosen-js/chosen.jquery.js';
import Vue from 'vue';
window.axios = require('axios')

document.addEventListener("DOMContentLoaded", function() {
    const authToken = document.getElementById('authToken')
    if(authToken){
        const headerAuthToken = `Bearer ${authToken.value}`;
        window.axios.defaults.headers.common['Authorization'] = `${headerAuthToken}`;
    }

    Vue.use(Vuex)
    Vue.use(BootstrapVue)
    Vue.use(IconsPlugin)

    Vue.directive('chosen', {
        inserted: function (el, binding, vnode) {
            $(el).chosen({
                width: '100%',
                allow_single_deselect: true,
                no_results_text: "Sin resultados para: ",
                placeholder_text_single: "Seleccione una opción",
                placeholder_text_multiple: "Seleccione una o más opciones",
                search_contains: true
            });

            $(el).on('change', function () {
                if (binding.expression && vnode.context) {
                    vnode.context[binding.expression] = $(el).val();
                }
            });
    
            Vue.nextTick(() => {
                $(el).trigger("chosen:updated");
            });
        },
        update: function (el) {
            $(el).trigger("chosen:updated");
        },
        unbind: function (el) {
            $(el).off('change');
            $(el).chosen('destroy');
        }
    });

    const store = new Vuex.Store(storeConfig)
    const app = new Vue({
        el: '#app',
        store,
    });

});
